import {CSSProperties, ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import Text from '../../common/component/Text';

export interface IProps {
  textKey: string;
  className?: string;
  textClassName?: string;
  beforeElement?: ReactNode;
  isFixed?: boolean;
  style?: CSSProperties;
}

export default function NoItems({
  textKey,
  className,
  textClassName,
  beforeElement,
  isFixed = true,
  style,
}: IProps) {
  const {t} = useTranslation();

  return (
    <div
      className={cn('flex-center text-center', className, {
        'fixed inset-0 h-full': isFixed,
      })}
      style={style}
    >
      {beforeElement}
      <Text className={cn('s16-regular-grey08', textClassName)}>
        {t(textKey)}
      </Text>
    </div>
  );
}
